module.exports = __webpack_public_path__ + "static/img/S08.afcf021.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/S08.png
// module id = aTss
// module chunks = 7